<template>
<div
    :class="{ 'summary_outer_container' : true, 'summary_outer_container_selected' : is_selected }"
>
    <div
        v-on:click="onClick"
        :class="{ 'main' : true, 'main_selected': is_selected, 'main_unread' : is_unread }"
    >
        <div class="icon_container">
            <m-avatar
                :avatar="summary.getAvatar(0)"
            />
        </div>
        <div class="summary_container">
            <span class="label_line">{{ summary.label_line }}</span><br/>
            <span class="last_message_line">{{ summary.getLastMessageLine() }}</span>
        </div>
        <div class="time_container">
            {{age}}<br>

            <v-menu
                bottom
                offset-y
                v-model="show_context_menu"
            >
                <template v-slot:activator="{  }">

                    <v-icon

                        small
                        v-on:click.stop="onClickContextMenu"
                    >
                        mdi-dots-vertical
                    </v-icon>

                </template>

                <v-list>
                    <template v-for="(item, index) in menu_items">
                        <!-- Regular item -->
                        <v-list-item
                            v-if="!item.admin_only"
                            :key="index"
                            v-on:click="onClickItem(item)"
                            :disabled="item.disabled"
                        >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>

                        <!-- Admin-only item -->
                        <m-restricted-menu-list-item
                            v-else
                            :key="'admin-'+index"
                            v-on:click="$rc.$state.isSystemsAdmin() ? onClickItem(item) : null"
                            :text="item.text"
                        />
                    </template>
                </v-list>

            </v-menu>
        </div>
    </div>
    <div
        v-if="summary.data.rc_tags != null && summary.data.rc_tags.length != 0"
        style="margin-left: 70px; line-height: 35px;"
    >
        <v-chip
            v-for="(item, index) in summary.data.rc_tags"
            :key="'rc_tag_chip_'+index"
            style="margin-right: 5px"
            :color="item.color"
        >
            {{item.label}}
        </v-chip>
    </div>

</div>
</template>

<script>
export default {
    props: {
        summary: {
            type: Object,
            default: () => { return {}; }
        },

        selected_conversation_id: {
            type: String,
            default: () => { return 'not-this-conversation'; }
        },

        can_transmit: {
            type: Boolean,
            default: () => { return false; }
        },

        org_endpoint: {
            type: Object,
            default: () => { return {}; }
        }
    },

    data() {
        return {
            show_context_menu: false,
        }
    },

    computed: {
        age() {
            return this.summary.getHumanReadableLastMessageAge();
        },

        is_selected()
        {
            return this.selected_conversation_id === this.summary.getConversationId() || this.show_context_menu;
        },

        is_unread()
        {
            return !this.summary.getRead();
        },

        menu_items()
        {
            let ret = [];

            let other_endpoints = this.summary.getOtherEndpoints(this.summary.getForEndpoint());

            for ( let i = 0; i < other_endpoints.length; i++ )
            {
                let cur_endpoint = other_endpoints[i];
                let cur_label = this.summary.getLabelOfEndpoint(cur_endpoint);

                ret.push({
                    'text' : 'Edit Contact '+cur_label+'...',
                    'action' : 'edit_label',
                    'conversation_id': this.summary.getConversationId(),
                    'endpoint': cur_endpoint,
                    'label': cur_label.startsWith("(") ? '' : cur_label,
                    'disabled' : false,
                });
            }

            ret.push({
                'text' : this.summary.getRead() ? 'Mark as unread' : 'Mark as read',
                'action' : 'set_read',
                'conversation_id': this.summary.getConversationId(),
                'read_value': !this.summary.getRead()
            });

            ret.push({
                'text' : 'Edit tags...',
                'action' : 'edit_tags',
                'conversation_id': this.summary.getConversationId(),
                'read_value': !this.summary.getRead(),
                'rc_tag_ids': this.summary.data.rc_tag_ids,
            });


            if ( this.summary.data.state == 'active' )
            {
                ret.push({
                    'text' : 'Archive',
                    'action' : 'set_conversation_state',
                    'conversation_id': this.summary.getConversationId(),
                    'new_state': 'archived'
                 });

                 ret.push({
                    'text' : 'Archive all conversations older than...',
                    'action' : 'archive_all_conversations_older_than',
                    'conversation_id': this.summary.getConversationId(),
                    'new_state': 'archived'
                 });

                ret.push({
                    'text' : 'Block (spam) conversation...',
                    'action' : 'change_spam_state',
                    'conversation_id': this.summary.getConversationId(),
                    'is_spam' : true
                 });
            }
            else if ( this.summary.data.state == 'archived' )
            {
                ret.push({
                    'text' : 'Unarchive',
                    'action' : 'set_conversation_state',
                    'conversation_id': this.summary.getConversationId(),
                    'new_state': 'active'
                 });

                ret.push({
                    'text' : 'Block (spam) conversation...',
                    'action' : 'change_spam_state',
                    'conversation_id': this.summary.getConversationId(),
                    'is_spam' : true
                 });
            }
            else if ( this.summary.data.state == 'spam' )
            {
                ret.push({
                    'text' : 'Unblock conversation...',
                    'action' : 'change_spam_state',
                    'conversation_id': this.summary.getConversationId(),
                    'is_spam' : false
                 });
            }

            ret.push({
                'text' : 'Link to conversation...',
                'action' : 'admin_link_to_conversation',
                'conversation_id': this.summary.getConversationId(),
                'endpoint' : this.summary.getForEndpoint(),
                'admin_only': true
            });

           return ret;
        }
    },

    methods: {
        onClick() {
            this.$emit('select-conversation',this.summary.getConversationId());
        },

        onClickContextMenu()
        {
            this.show_context_menu = true;
        },

        onClickItem(item)
        {
            this.$emit('conversation-action',item);
        },
    },
}
</script>

<style lang="scss" scoped>

div.summary_outer_container
{
    cursor: pointer;

    padding: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

div.summary_outer_container:hover,
div.summary_outer_container_selected
{
    background-color: #F1F3F4;
}

div.main
{
    width: 100%;
    height: 40px;

    display: flex;
    flex-direction: row;
}

/* Placeholder for future styling */

div.main_unread
{
    font-weight: 550;
}


div.icon_container
{
    flex-grow: 0;

    text-align: center;
}

div.summary_container
{
    flex-grow: 1;
    font-family: Roboto;

    padding-left: 16px;
    padding-right: 16px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 18px;
}

div.time_container
{
    flex-grow: 0;
    font-size: 12px;
    font-family: "Google Sans",Roboto,arial,sans-serif;
    white-space: nowrap;
    text-align: right;
}

.label_line
{
    color: #202124;
    font-size: 15px;
}

.last_message_line
{
    color: #202124;
    font-size: 14px;
    max-width: 5em;
}

</style>

